<app-dashboard-layout [notDashboard]="true" [downloader]="downloader" [loading]="loading || skeletonLoader">
    <app-notification-alert class="pt-4" [data]="notification"></app-notification-alert>
</app-dashboard-layout>